export default __webpack_public_path__ + "static/media/yellow-2.7c2b887f.svg";